export const stickyElement = (selector) => {
    const _config = {
        sliderContainer: selector
    };

    const sliderContainer = document.querySelector(_config.sliderContainer);

    if (sliderContainer) {
        const sliderHeight = sliderContainer.offsetHeight;
        const windowHeight = window.innerHeight;

        // only make slider sticky if window is large enough
        // otherwise thumbnails will never be visible
        if (sliderHeight < windowHeight) {
            sliderContainer.classList.add('sw-sticky');
        }
    }
};
